import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7a0a79fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_2 = { class: "modal-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pregunta enviada", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", { style: {"font-size":"14px"} }, "¡La plataforma se pone en marcha!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Puedes llevar un seguimiento de las respuestas recibidas desde la sección 'Mis Preguntas' del menú (sección Foro) Una vez recibida una respuesta satisfactoria, no olvides marcar la pregunta como resuelta. ¡Gracias!")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "new-question" }, "Aceptar", -1))
const _hoisted_7 = { class: "animate form" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Redactar Pregunta", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Título de la Pregunta", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Debe ser conciso y no extenderse más allá de 150 caracteres", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Explicación del problema", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Detalla cuál es el problema al que te estás enfrentando que no logras solucionar. Asegúrate de darle un formato legible.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Lo que he intentado hacer hasta ahora", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Explica a los compañeros qué has tratado de realizar para solucionarlo", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Repositorio (opcional)", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Prové un enlace al repositorio con tu código para ayudar a reproducir el error", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import ForumService from '@/services/ForumService'
import { useAuth } from '@/store/useAuth'
import useWindowWidth from '@/composables/useWindowWidth'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import main from '@/data/main.js'



export default /*#__PURE__*/_defineComponent({
  __name: 'ForumCourseWriteView',
  setup(__props) {

const toast = useToast()
const service = new ForumService()
const store = useAuth()
const route = useRoute()
const name = ref('')
const description = ref('')
const tries = ref('')
const repository = ref('')
const course_id = route.params.course_id
const lesson_id = route.params.lesson_id
const showFeedback = ref(false)
const {windowWidth} = useWindowWidth()
const descriptionBox = ref()
const triesBox = ref()
const course_id_str = Array.isArray(course_id) ? course_id[0] : course_id;
const lesson_id_str = Array.isArray(lesson_id) ? lesson_id[0] : lesson_id;

const hanldeDescription = () => {
    description.value = descriptionBox.value.getHTML()
}

const hanldeTries = () => {
    tries.value = triesBox.value.getHTML()
}

const storeQuestion = async () => {
    if (!store.token) { return; }
    const response = await service.WriteQuestion(store.token, true, name.value, description.value, parseInt(course_id_str), undefined, parseInt(lesson_id_str), tries.value, repository.value)
    console.log("response", response)
    if (response != true) {
        toast.showToast("Upps... Algo salió mal.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    showFeedback.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (showFeedback.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (_unref(windowWidth) >= 1000)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(main).NEW_QUESTION_COURSE,
                    style: {"width":"100%"}
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              _hoisted_5,
              _createVNode(_component_RouterLink, {
                to: {name: 'my-questions'},
                style: {"text-decoration":"none"}
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
          type: "text",
          max: "150",
          maxlength: "150",
          required: "",
          placeholder: "Ejemplo: Error - No se reconoce el comando npm cuando trato de lanzar el servidor de pruebas"
        }, null, 512), [
          [_vModelText, name.value]
        ]),
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _createVNode(_component_quill_editor, {
          ref_key: "descriptionBox",
          ref: descriptionBox,
          theme: "snow",
          modelValue: description.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
          toolbar: "full",
          "onUpdate:content": hanldeDescription
        }, null, 8, ["modelValue"]),
        _hoisted_15,
        _hoisted_16,
        _hoisted_17,
        _createVNode(_component_quill_editor, {
          ref_key: "triesBox",
          ref: triesBox,
          theme: "snow",
          modelValue: tries.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tries).value = $event)),
          toolbar: "full",
          "onUpdate:content": hanldeTries
        }, null, 8, ["modelValue"]),
        _hoisted_18,
        _hoisted_19,
        _hoisted_20,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((repository).value = $event)),
          type: "text",
          placeholder: "Ejemplo: https://github.com/ademass/ejemplo"
        }, null, 512), [
          [_vModelText, repository.value]
        ]),
        _hoisted_21,
        _createElementVNode("button", {
          class: "new-question",
          onClick: storeQuestion
        }, [
          _createTextVNode("Enviar Pregunta "),
          _createVNode(_component_v_icon, {
            name: "io-send",
            style: {"margin-left":"10px"}
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})